import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

function MobileGate() {
  const { resolved: theme } = useTheme();
  const ui = theme.ui || {};

  return (
    <div className="h-screen flex items-center justify-center p-8 ui-bg" style={{ backgroundColor: ui.bg, color: ui.text }}>
      <div className="text-center max-w-sm">
        <h1 className="text-4xl font-medium tracking-tight mb-6">co/plot</h1>
        <p className="text-sm mb-4" style={{ color: ui.emptyStateText }}>
          This tool is designed for desktop use.
        </p>
        <p className="text-sm">
          Please expand your window or visit on a larger screen.
        </p>
        <div className="mt-8 text-xs" style={{ color: ui.textSecondary }}>
          Minimum width: 1024px
        </div>
      </div>
    </div>
  );
}

export default MobileGate;
